<template>
	<section class="featured-section bg-blue-dark">
				<div class="container">
					
					<div class="row">
						<div class="col-md-12 col-12 col-sm-12 col-lg">
							<div class="">
								<VueSlickCarousel v-bind="settingCategory">
									<div class="">
										<div class="featured-card bg-warning">
											<h2 class="text-white">Metode belajar <i>LEARN, DO & TEACH</i></h2>
											<p class="text-white">Gaya belajar di Pejuang Pendidik ini pertama dan satu-satunya di Indonesia, menggabungkan otak kanan dan otak kiri, serta sudah terbukti bikin materi nempel terus di otak</p>
											<!-- <a href="course.html" class="text-white">View More <i class="fas fa-caret-right right-nav-blue"></i></a> -->
										</div>
									</div>
									
									<div class="">
										<div class="featured-card bg-primary">
											<h2 class="text-white">Coach Terbaik</h2>
											<p class="text-white">Kami pilihkan coach terbaik di bidangnya, yaitu orang yang lebih dahulu praktik dan berhasil</p>
										</div>
									</div>
									<div class="">
										<div class="featured-card bg-info">
											<h2 class="text-white">24/7</h2>
											<p class="text-white">Sobat Pejuang bisa mengakses pembelajar kapanpun dan dimanapun dan kami menyebutnya sebagai belajar tanpa batas!</p>
										</div>
									</div>
									
									<div class="">
										<div class="featured-card bg-purple">
											<h2 class="text-white">Materi lengkap dan komunikatif</h2>
											<p class="text-white">Materi yang kami susun berdasarkan riset dari coach terbaik dalam bentuk video maupun teks</p>
										</div>
									</div>
									<div class="">
										<div class="featured-card bg-success">
											<h2 class="text-white">Fitur Lengkap dan Mudah Digunakan</h2>
											<p class="text-white">Kami menyiapkan pembelajaran tatap muka, pembelajaran mandiri dengan fitur yang lengkap dan mudah digunakan </p>
										</div>
									</div>
									

								</VueSlickCarousel>
							</div>
						</div>
						
						
					</div>
				</div>
	</section>

</template>


<script>
import VueSlickCarousel from 'vue-slick-carousel'

  export default {
    name: 'MyComponent',
    components: { VueSlickCarousel },
    data() {
      return {
        
        settingCategory: {
            
            "infinite": true,
            "slidesToShow": 2,
            // "speed": 500,
            "rows": 1,
            "slidesPerRow": 1,
            
            // arrows: false,
            // "dots": false,
            // "infinite": false,
            // "speed": 500,
            // "slidesToShow": 6,
            // "slidesToScroll": 6,
            // "initialSlide": 0,
            "responsive": [
                {
                "breakpoint": 1024,
                "settings": {
                    "slidesToShow": 2,
                    "slidesToScroll": 1,
                }
                },
                {
                "breakpoint": 600,
                "settings": {
                    "slidesToShow": 2,
                    "slidesToScroll": 1,
                }
                },
                {
                "breakpoint": 480,
                "settings": {
                    "slidesToShow": 1,
                    "slidesToScroll": 1,
            		"rows": 1,
                }
                }
            ]
            }
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Category/Benefits/index.vue